import ScmPageRenderer from '@/components/scm/ScmPageRenderer';
import { inventoryPageDef } from '@/components/scm/scm-page-defs';

export default function ScmInventoryPage() {
  return <ScmPageRenderer pageDef={inventoryPageDef} />;
}
